export enum WasherEnhancementVariant {
  Enhanced = 'enhanced',
  Control = 'control',
}
